module.exports = __webpack_public_path__ + "img/r-cb6-111.ded2828c.gif";